<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="1"></Aide>

        <h3 class="titreSolu text-center">Gestion machine</h3>
            <b-collapse id="collapse-2">
            <h4 class="text-center">Créer une machine</h4>
            <div>
                <div class="row" style="margin-top: 75px;">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Nom
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="nomMachine" name="nomMachine" placeholder="Nom">
                    </div>
                </div>
                <br />
                <div class="row" style="margin-top: 75px;">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Immatriculation
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="immatMachine" name="immatMachine" placeholder="Immatriculation">
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Type
                    </div>
                    <div class="col-7">
                        <select v-model="typeMachine" class="form-control" name="typeMachine">
                            <option v-for="(lType, key) in listMachineType" :key="key"
                                    v-bind:value="lType['@id']">{{ lType.intitule }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="addMachine()" >
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        </b-collapse>
        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>

        <div>
            <h4 class="text-center">Liste des machines existantes</h4>
            <div class="row">
                <div class="col-12 text-right">
                    <button v-b-toggle="'collapse-2'" class="btn btn-primary"><i class="fa-solid fa-plus"></i> Ajout machine</button>
                </div>
            </div>
            <table  v-if="listMachine.length>0" class="table table-striped table-bordered " >
                <tr>
                    <th class="thtab">Nom</th>
                    <th class="thtab">Immatriculation</th>
                    <th class="thtab">Type</th>
                    <th class="thtab"></th>
                    <th class="thtab"></th>
                </tr>
                <tr v-for="(machine, key) in listMachine" :key="key" >
                    <td>
                        <span v-if="keyUpd!=key">{{machine.nom}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="nomMachineUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">{{machine.immat}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="immatMachineUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                            <span v-for="(lType, key) in listMachineType" :key="key">
                                <span v-if="lType['@id']==machine.typeMachine">{{lType.intitule}}</span>
                            </span>
                        </span>
                        <select v-if="keyUpd==key" v-model="typeMachineUpd" class="form-control" name="typeMachine">
                            <option v-for="(lType, key) in listMachineType" :key="key"
                                    v-bind:value="lType['@id']">{{ lType.intitule }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="keyUpd!=key" class="fa-solid fa-pen-to-square fa-2x text-warning" @click="beforeUpdate(key)"></i>
                        <i v-if="keyUpd==key" class="fa-solid fa-check fa-2x text-success" @click="valideUpdate(key)"></i>
                        &nbsp;
                        <i v-if="keyUpd==key" class="fa-solid fa-xmark fa-2x text-danger" @click="cancel()"></i>
                    </td>
                    <td>
                        <i class="fa-regular fa-trash-can fa-2x text-danger" @click="deleteObjet(key)"></i>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row">
            <div class="col-12 text-center text-info">
                {{listMachine.length}} entité(s)
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "Machine",
        props: ['token', 'site', 'user', 'racine', 'userId','systemeClient'],
        data() {
            return {
                nomMachine:'',immatMachine:'',typeMachine:1,errors:[],msgs:[],listMachineType:[],
                listMachine:[], nomMachineUpd:'', immatMachineUpd:'',keyUpd:null,checkValideMachin:true
            };
        },
        methods:
        {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            addMachine()
            {
                this.errors = [];
                this.msgs = [];
                if(this.nomMachine!='') {
                    console.log(this.nomMachine)


                    var formdata = new FormData();
                    formdata.append('nom', this.nomMachine);
                    formdata.append('immat', this.immatMachine);
                    formdata.append('type', this.typeMachine);


                    fetch(this.racine + this.site + 'api/machines', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                        body: JSON.stringify({
                            nom: this.nomMachine,
                            immat: this.immatMachine,
                            typeMachine: this.typeMachine,
                            actif: 1,
                            systemeClient: this.systemeClient
                        })
                        /*body: "{\"nom\":\"" + this.nomMachine + "\"," +
                        "\"immat\": \"" + this.immatMachine + "\"," +
                        "\"typeMachine\": \"" + this.typeMachine + "\"," +
                        "\"actif\": 1," +
                        "\"systemeClient\": \"" + this.systemeClient + "\"" +
                        "}"*/
                    }).then(response => response.json())
                        .then(json => {
                            console.log(json);
                            if (json['@type'] == "hydra:Error") {
                                this.errors.push("Ce nom est déjà utilisé.")
                                this.popup()
                            }
                            else if (json['id'] > 0) {
                                this.msgs.push("Ajout de la machine effectué.")
                                this.getMachines()
                                this.nomMachine = ''
                                this.immatMachine = ''
                                this.popup()
                            }
                            else {
                                this.errors.push("Un problème inconnu s'est produit.")
                                this.popup()
                            }
                        })
                }
                else
                {
                    this.errors.push('Vous devez remplir le nom.');
                }


            },
            getMachines()
            {
                fetch(this.racine + this.site + 'api/machines?systemeClient='+this.systemeClient+"&actif=1", {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachine = json['hydra:member']
                        }
                    })
                })
            },
            beforeUpdate(keyMachine)
            {
                //on charge les données de la ligne dans les variables pour l'update
                this.keyUpd = keyMachine
                this.nomMachineUpd = this.listMachine[this.keyUpd].nom
                this.immatMachineUpd = this.listMachine[this.keyUpd].immat
                this.typeMachineUpd = this.listMachine[this.keyUpd].typeMachine
            },
            valideUpdate(key)
            {
                this.errors = [];
                this.msgs = [];
                if(this.nomMachineUpd!='') {
                    this.$confirm(
                        {
                            title: 'Etes vous sûr?',
                            message: 'Etes vous sur de vouloir modifier ' + this.listMachine[key].nom + '?',
                            button: {
                                yes: 'Oui',
                                no: 'Non'
                            },
                            callback: confirm => {
                                if (confirm == true) {
                                    console.log(this.systemeClient)
                                    fetch(this.racine + this.site + 'api/machines/'+this.listMachine[key].id, {
                                        method: 'PUT',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                        body: "{\"nom\":\"" + this.nomMachineUpd + "\"," +
                                        "\"typeMachine\": \"" + this.typeMachineUpd + "\"," +
                                        "\"immat\": \"" + this.immatMachineUpd + "\"," +
                                        "\"actif\": 1," +
                                        "\"systemeClient\": \"" + this.systemeClient + "\"" +
                                        "}"
                                    }).then(response => response.json())
                                        .then(json => {
                                            console.log(json);
                                            if (json['@type'] == "hydra:Error") {
                                                this.errors.push("Ce nom est déjà utilisé.")
                                                this.popup()
                                            }
                                            else if (json['id'] > 0) {
                                                this.msgs.push("Modification de la machine effectué.")
                                                this.getMachines()
                                                this.nomMachine = ''
                                                this.immatMachine = ''
                                                this.popup()
                                                this.keyUpd = null
                                            }
                                            else {
                                                this.errors.push("Un problème inconnu s'est produit.")
                                                this.popup()
                                            }
                                        })
                                }
                            }
                        }
                    )
                }
                else
                {
                    this.errors.push('Vous devez remplir le nom.');
                }
            },
            popup()
            {
                this.$bvModal.show('modalInfo')
                setTimeout(() => {//on laisse le message quelques instants
                    this.$bvModal.hide('modalInfo')
                    this.errors = []
                    this.msgs = []
                }, 2000)
            },
            cancel()
            {
                this.keyUpd = null
            },
            deleteObjet(key)
            {
                var self = this
                this.$confirm(
                    {
                        title: 'Etes vous sûr?',
                        message: 'Etes vous sur de vouloir supprimer ' + this.listMachine[key].nom + '?',
                        button: {
                            yes: 'Oui',
                            no: 'Non'
                        },
                        callback: confirm => {
                            if (confirm == true) {
                                fetch(this.racine + this.site + 'api/delete_machine/'+this.listMachine[key].id, {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                }).then(function(response) {
                                    console.log(response.ok)
                                    if(response.ok == true)
                                    {
                                        self.getMachines()
                                        self.keyUpd = null
                                        self.msgs.push("Suppression de la machine effectuée.")
                                        self.popup()
                                    }
                                    else {
                                        self.errors.push("Un problème inconnu s'est produit.")
                                        self.popup()
                                    }

                                })
                            }
                        }
                    }
                )

            },
            getMachineTypes()
            {
                fetch(this.racine + this.site + 'api/machine_types?systemeClient='+this.systemeClient, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachineType = json['hydra:member']
                        }
                    })
                })
            },
        },
        mounted() {
            this.getMachines()
            this.getMachineTypes()

        },
        created() {
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>